import React, { useState } from "react";
import "./Register.css";
import styles from "./Register.module.css";
import fb from "../../assets/images/fb.png";
import google from "../../assets/images/google.png";
import yahooIcon from "../../assets/images/yahoo.png";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { useNavigate } from "react-router-dom";
// import yahoo from "yahoo-sdk";
const Register = () => {
  let navigate = useNavigate();
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const [loginHandler, setLoginHandler] = useState({
    email: "",
    phone: "",
  });
  const [unverifiedEmail, setUnverifiedEmail] = useState("");
  const [unverifiedPhoneNumber, setUnverifiedPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [googleEmailVerified, setGoogleEmailVerified] = useState(false);
  const [facebookEmailVerified, setFacebookEmailVerified] = useState(false);
  const handleFacebookLogin = () => {
    window.FB.login(
      (response) => {
        if (response.authResponse) {
          const { accessToken } = response.authResponse;
          window.FB.api("/me", { fields: "email" }, (response) => {
            const { email } = response;
            // TODO: Send accessToken and email to backend for verification
            setEmail(email);
            console.log(email);
            setFacebookEmailVerified(true);
            OAuthVerify(email);
          });
        }
      },
      { scope: "email" }
    );
  };

  const loginOnChange = (e) => {
    setLoginHandler({ ...loginHandler, [e.target.name]: [e.target.value] });
  };
  const submit = (e) => {
    console.log(unverifiedEmail);
    console.log("Submit");
    if (unverifiedEmail === "" && unverifiedPhoneNumber === "") return;
    axios
      .post(backend_base + "/user/otp/register", {
        email: unverifiedEmail,
        phone_number: unverifiedPhoneNumber,
      })
      .then((response) => {
        if (response.status === 200) {
          //goto next page
          if (typeof localStorage !== "undefined") {
            if (unverifiedEmail.length > 0) {
              localStorage.removeItem("unverified_phone_number");
              localStorage.setItem("unverified_email", unverifiedEmail);
            } else if (unverifiedPhoneNumber.length > 0) {
              localStorage.removeItem("unverified_email");
              localStorage.setItem(
                "unverified_phone_number",
                unverifiedPhoneNumber
              );
            }
            navigate("/otp");
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleGoogleLogin = useGoogleLogin({
    onSuccess: (codeResponse) => {
      console.log(codeResponse);
      const access_token = codeResponse.access_token;
      axios
        .get("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          if (response.data.email_verified) {
            setEmail(response.data.email);
            console.log(response.data.email);
            setGoogleEmailVerified(true);
            console.log("Setting google Email Verified to TRUE");
            OAuthVerify(
              response.data.email,
              response.data?.given_name,
              response.data?.family_name
            );
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onError: (error) => console.log(error),
  });

  // const handleYahooLogin = () => {
  //   //!TODO: Take EVery API_KEY TO .env FILE / BACKEND
  //   const clientId =
  //     "dj0yJmk9ak1ERUJtQ1F3dG1vJmQ9WVdrOVRuWXhjVzVvUzB3bWNHbzlNQT09JnM9Y29uc3VtZXJzZWNyZXQmc3Y9MCZ4PTc2";
  //   const redirectUri = "localhost:3000/login/yahooOAuth";
  //   const lang = navigator.language;
  //   const url =
  //     `https://api.login.yahoo.com/oauth2/request_auth_fe?client_id=` +
  //     clientId +
  //     `&redirect_uri=` +
  //     redirectUri +
  //     `&response_type=code&language=` +
  //     lang;
  //   const mainUrl =
  //     "https://api.login.yahoo.com/oauth2/request_auth_fe?client_id=dj0yJmk9ak1ERUJtQ1F3dG1vJmQ9WVdrOVRuWXhjVzVvUzB3bWNHbzlNQT09JnM9Y29uc3VtZXJzZWNyZXQmc3Y9MCZ4PTc2&response_type=code&redirect_uri=localhost:3000/login/yahooOAuth&language=en-US";

  //   // Open the authorization URL in a popup window
  //   const popupWindow = window.open(mainUrl, "_blank", "height=800,width=600");

  //   // Listen for the message event to be fired when the popup window is closed
  //   window.addEventListener("message", async (event) => {
  //     try {
  //       // Verify that the message is from the popup window and contains authorization data
  //       if (
  //         event.origin === window.location.origin &&
  //         event.source === popupWindow &&
  //         event.data &&
  //         event.data.code &&
  //         event.data.state
  //       ) {
  //         const { code, state } = event.data;
  //         console.log("GOT THE CODE");
  //         // Use the authorization code to get an access token
  //         const { data: accessToken } = await axios.post("/api/yahoo/token", {
  //           code,
  //           state,
  //         });

  //         // Use the access token to get the user's email address
  //         const { data: userInfo } = await axios.get("/api/yahoo/userinfo", {
  //           headers: {
  //             Authorization: `Bearer ${accessToken}`,
  //           },
  //         });

  //         console.log(userInfo);

  //         // Close the popup window
  //         popupWindow.close();

  //         // Use the extracted code parameter as needed
  //         console.log(code);
  //       }
  //     } catch (error) {
  //       console.log("ERROR");
  //       console.log(error);
  //     }
  //   });
  // };

  // for japan

  const handleYahooLogin = () => {
    //!TODO: Take EVery API_KEY TO .env FILE / BACKEND
    const clientId =
      "dj0yJmk9ak1ERUJtQ1F3dG1vJmQ9WVdrOVRuWXhjVzVvUzB3bWNHbzlNQT09JnM9Y29uc3VtZXJzZWNyZXQmc3Y9MCZ4PTc2";
    const redirectUri = "http://localhost:3000/login/yahooOAuth"; // Update with your actual redirect URI
    const lang = navigator.language;
    const url =
      `https://auth.login.yahoo.co.jp/yconnect/v2/authorization?client_id=` +
      clientId +
      `&redirect_uri=` +
      redirectUri +
      `&response_type=code&scope=openid%20email&nonce=12345&prompt=login&lang=` +
      lang;
    const mainUrl =
      `https://auth.login.yahoo.co.jp/yconnect/v2/authorization?client_id=` +
      clientId +
      `&redirect_uri=` +
      redirectUri +
      `&response_type=code&scope=openid%20email&nonce=12345&prompt=login&lang=` +
      lang;

    // Open the authorization URL in a popup window
    const popupWindow = window.open(mainUrl, "_blank", "height=800,width=600");

    // Listen for the message event to be fired when the popup window is closed
    window.addEventListener("message", async (event) => {
      try {
        // Verify that the message is from the popup window and contains authorization data
        if (
          event.origin === window.location.origin &&
          event.source === popupWindow &&
          event.data &&
          event.data.code &&
          event.data.state
        ) {
          const { code, state } = event.data;
          console.log("GOT THE CODE");
          // Use the authorization code to get an access token
          const { data: accessToken } = await axios.post("/api/yahoo/token", {
            code,
            state,
          });

          // Use the access token to get the user's email address
          const { data: userInfo } = await axios.get("/api/yahoo/userinfo", {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          });

          console.log(userInfo);

          // Close the popup window
          popupWindow.close();

          // Use the extracted code parameter as needed
          console.log(code);
        }
      } catch (error) {
        console.log("ERROR");
        console.log(error);
      }
    });
  };

  const OAuthVerify = (email, firstname, lastname) => {
    axios
      .post(backend_base + "/user/otp/OAuthEmailVerified", {
        email: email,
      })
      .then((response) => {
        if (response.status === 200) {
          //goto next page
          if (typeof localStorage !== "undefined") {
            localStorage.setItem("verified_email", email);
            localStorage.setItem("registration_token", response.data.token);
            if (firstname) {
              localStorage.setItem("firstname", firstname);
            }
            if (lastname) {
              localStorage.setItem("lastname", lastname);
            }
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const RedirectMemberRegistration = () => {
    if (
      typeof localStorage !== "undefined" &&
      localStorage.getItem("registration_token") !== null
    ) {
      navigate("/member-registration");
    }
  };
  return (
    <div>
      <Header />
      {!googleEmailVerified && !facebookEmailVerified && (
        <div className="login">
          <div className="login_body d-flex flex-column pt-5">
            <h3 className="login_position_center">会員登録</h3>
            <h6 className="login_first_text">
              ソーシャルアカウントで無料会員登録をする
            </h6>
            <div className="d-flex flex-column align-items-center">
              <ThirdPartyLoginDiv
                imgSource={google}
                name={"Googleで会員登録"}
                callBackToLogin={handleGoogleLogin}
                bgColor="white"
                fontColor="rgba(0,0,0, 0.4)"
              />
              <ThirdPartyLoginDiv
                imgSource={fb}
                name={"Fecebookで会員登録"}
                callBackToLogin={handleFacebookLogin}
                bgColor="#1877F2"
                fontColor="white"
              />
              <ThirdPartyLoginDiv
                imgSource={yahooIcon}
                name={"Yahoo! JAPAN IDで会員登録"}
                callBackToLogin={handleYahooLogin}
                bgColor="#FF0033"
                fontColor="white"
                height="20px"
              />
            </div>
            <br />
            <hr className="login_middle_line" />
            <h6 className="login_first_text">
              またはメールアドレスや電話番号で会員登録をする
            </h6>
            <div class="igroup">
              {/* <div class="input-group-prepend"></div> */}
              <input
                onChange={(e) => setUnverifiedEmail(e.target.value)}
                type="email"
                value={unverifiedEmail}
                className="login_input"
                aria-label="Text input with checkbox"
                name="email"
                placeholder="Email Address"
              />
            </div>
            <h6 className="or">or</h6>
            <div class="igroup">
              {/* <div class="input-group-prepend"></div> */}
              <input
                onChange={(e) => setUnverifiedPhoneNumber(e.target.value)}
                type="text"
                className="login_input"
                aria-label="Text input with checkbox"
                name="phone"
                placeholder="Phone Number"
                value={unverifiedPhoneNumber}
              />
            </div>
            <h6 className="login_last">上記にSMS認証コードをお送りします。</h6>
            <button onClick={submit} type="button" class="button">
              Send
            </button>
          </div>
        </div>
      )}
      {googleEmailVerified && (
        <div className={styles.google_login_main_div}>
          <div className={styles.googleLogin}>
            <img src={google} className={styles.googleLogo} alt="googleLogo" />
            <div className={styles.googleHeader}>Googleで会員登録</div>
            <div className={styles.googleInfoText1}>
              My Aceが次のアクセス許可をリクエストしています
            </div>
            <div className={styles.googleInfoText2}>
              氏名、メールアドレス、電話番号
            </div>
            <button
              onClick={RedirectMemberRegistration}
              className={styles.googleGoButton}
            >
              連携してログイン
            </button>
            <button
              onClick={() => setGoogleEmailVerified(false)}
              className={styles.googleGoBackButton}
            >
              キャンセル
            </button>
          </div>
        </div>
      )}
      {facebookEmailVerified && (
        <div className={styles.google_login_main_div}>
          <div className={styles.googleLogin}>
            <img src={fb} className={styles.googleLogo} alt="fbLogo" />
            <div className={styles.googleHeader}>Facebookで会員登録</div>

            <div className={styles.googleInfoText1}>
              My Aceが次のアクセス許可をリクエストしています。
            </div>
            <div className={styles.googleInfoText2}>
              氏名、メールアドレス、電話番号
            </div>
            <button
              onClick={RedirectMemberRegistration}
              className={styles.googleGoButton}
            >
              連携してログイン
            </button>
            <button
              onClick={() => setFacebookEmailVerified(false)}
              className={styles.googleGoBackButton}
            >
              キャンセル
            </button>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

const ThirdPartyLoginDiv = ({
  imgSource,
  name,
  callBackToLogin,
  bgColor,
  fontColor = "black",
  height,
}) => {
  return (
    <div
      className="social_icon_container"
      style={{
        backgroundColor: bgColor,
        color: fontColor,
        border: "1px solid rgba(0,0,0,0.05)",
        cursor: "pointer",
      }}
      onClick={() => {
        console.log(`${name} social item button in clicked`);
        callBackToLogin();
      }}
    >
      <img
        className="social_icon"
        src={imgSource}
        alt={name}
        style={height ? { height: "20px", width: "36px" } : {}}
      />
      <span className="social_name">{name}</span>
    </div>
  );
};

export default Register;
